import {Location} from 'react-router-dom'
import {
  AlarmCentersPermissions,
  B2cPermission,
  CameraMosaicPermissions,
  ClientsPermissions,
  CompaniesPermissions,
  CredentialsPermissions,
  DashboardPermissions,
  DevicesPermissions,
  EdgeServerPermissions,
  EventsPermissions,
  FacialRecognitionPermissions,
  ImagensPermissions,
  LprPermissions,
  NotificationsPermissions,
  RegistersListsMenuPermissions,
  Permission,
  QuotasPermissions,
  ServerEntradaPermissions,
  ServerSaidaPermissions,
  UploadDatasetFilePermissions,
  UserPermissions,
} from 'src/common/utils/PermissionsList'

import clientsIconSelected from 'src/images/IconClientSelected.svg'
import adminIcon from 'src/images/adminIcon.svg'
import adminIconSelected from 'src/images/adminIconSelected.svg'
import camerasIcon from 'src/images/cameras.svg'
import camerasIconSelected from 'src/images/camerasSelected.svg'
import companyIconSelected from 'src/images/companySelected.svg'
import credentialsIcon from 'src/images/credentialsIcon.svg'
import credentialsIconSelected from 'src/images/credentialsIconSelected.svg'
import dashboardIcon from 'src/images/dashboardIcon.svg'
import dashboardIconSelected from 'src/images/dashboardIconSelected.svg'
import dataCompanyIcon from 'src/images/dataCompanyIcon.svg'
import dataCompanyIconSelected from 'src/images/dataCompanyIconSelected.svg'
import edgeServerNotSelected from 'src/images/edgeServerNotSelected.svg'
import edgeServerSelected from 'src/images/edgeServerSelected.svg'
import eventIcon from 'src/images/eventIcon.svg'
import eventIconsSelected from 'src/images/eventIconsSelected.svg'
import FacialRecognitionIcon from 'src/images/faceRecognitionIcon.svg'
import FacialRecognitionSelectedIcon from 'src/images/faceRecognitionSelectedIcon.svg'
import companyIcon from 'src/images/iconCompany.svg'
import IconOpen from 'src/images/iconOpen.svg'
import IconOpenSelected from 'src/images/iconOpenSelected.svg'
import quotaIcon from 'src/images/iconQuotas.svg'
import incomingServer from 'src/images/incomingServerIcon.svg'
import incomingServerSelected from 'src/images/incomingServerSelected.svg'
import licensePlateIcon from 'src/images/licensePlateIcon.svg'
import licensePlateIconSelected from 'src/images/licensePlateIconSelected.svg'
import MosaicIcon from 'src/images/mosaicIcon.svg'
import MosaicIconSelected from 'src/images/mosaicIconSelected.svg'
import outgoingServer from 'src/images/outgoingServer.svg'
import outgoingServerSelected from 'src/images/outgoingServerSelected.svg'
import quotaIconSelected from 'src/images/quotaSelected.svg'
import registersIcon from 'src/images/registersIcon.svg'
import registersIconSelected from 'src/images/registersIconSelected.svg'
import SettingsIcon from 'src/images/settings.svg'
import SettingsIconSelected from 'src/images/settingsSelected.svg'
import usersIcon from 'src/images/users.svg'
import usersIconSelected from 'src/images/usersSelected.svg'
import {User} from 'src/services/api'
import {InitialRoutesWithPermissions} from '../../../routes/RoutesPageFunctions'

export type SidebarItem = {
  name: string
  link: string
  icon: string
  iconOpen?: string
  iconOpenSelected?: string
  iconSelected: string
  submenu?: SidebarItem[]
  permission: Permission[]
  permissionMatch?: 'all' | 'any'
  hidden?: boolean
}

export const allSidebarItems: SidebarItem[] = [
  {
    name: 'Acesso Negado',
    link: 'forbidden',
    icon: dashboardIcon,
    iconSelected: dashboardIconSelected,
    permission: [],
    hidden: true,
  },
  {
    name: 'Dashboard',
    link: 'dashboard',
    icon: dashboardIcon,
    iconSelected: dashboardIconSelected,
    permission: DashboardPermissions,
  },
  {
    name: 'Eventos',
    link: 'events',
    icon: eventIcon,
    iconSelected: eventIconsSelected,
    permission: EventsPermissions,
  },
  {
    name: 'Notificações',
    link: 'notifications',
    icon: '',
    iconSelected: '',
    permission: NotificationsPermissions,
    hidden: true,
  },
  {
    name: 'LPR',
    link: 'license-plate',
    icon: licensePlateIcon,
    iconSelected: licensePlateIconSelected,
    permission: LprPermissions,
  },
  {
    name: 'Mosaico',
    link: 'camera-mosaic',
    icon: MosaicIcon,
    iconSelected: MosaicIconSelected,
    permission: CameraMosaicPermissions,
  },
  {
    name: 'Reconhecimento facial',
    link: 'facial-recognition',
    icon: FacialRecognitionIcon,
    iconSelected: FacialRecognitionSelectedIcon,
    permission: FacialRecognitionPermissions,
  },
  {
    name: 'Imagens',
    link: 'transactions',
    icon: camerasIcon,
    hidden: true,
    iconSelected: camerasIconSelected,
    permission: ImagensPermissions,
  },
  {
    name: 'Camera Config B2C',
    link: 'camera-config',
    icon: dashboardIcon,
    iconSelected: dashboardIconSelected,
    permission: B2cPermission,
    hidden: true,
  },
  {
    name: 'Selecionar Planos',
    link: 'select-plan',
    icon: dashboardIcon,
    iconSelected: dashboardIconSelected,
    permission: B2cPermission,
    hidden: true,
  },
  {
    name: 'Status',
    link: 'status',
    icon: dashboardIcon,
    iconSelected: dashboardIconSelected,
    permission: B2cPermission,
    hidden: true,
  },
  {
    name: 'Upload de Dataset',
    link: 'upload-dataset',
    icon: dashboardIcon,
    iconSelected: dashboardIconSelected,
    permission: UploadDatasetFilePermissions,
    hidden: true,
  },
  {
    name: 'Cadastros',
    link: 'registers',
    icon: registersIcon,
    iconSelected: registersIconSelected,
    iconOpen: IconOpen,
    iconOpenSelected: IconOpenSelected,
    submenu: [
      {
        name: 'Dispositivos',
        link: 'registers/devices',
        icon: camerasIcon,
        iconSelected: camerasIconSelected,
        permission: DevicesPermissions,
      },
      {
        name: 'Clientes',
        link: 'registers/clients',
        icon: '',
        iconSelected: clientsIconSelected,
        permission: ClientsPermissions,
      },
      {
        name: 'Listas',
        link: 'registers/lists',
        icon: registersIcon,
        iconSelected: registersIconSelected,
        permission: RegistersListsMenuPermissions,
        permissionMatch: 'any',
      },
      {
        name: 'Usuários',
        link: 'registers/users',
        icon: usersIcon,
        iconSelected: usersIconSelected,
        permission: UserPermissions,
      },
      {
        name: 'Servidores de Borda',
        link: 'registers/edge-servers',
        icon: edgeServerNotSelected,
        iconSelected: edgeServerSelected,
        permission: EdgeServerPermissions,
      },
      {
        name: 'Central de Alarme',
        link: 'registers/alarm-centers',
        icon: '',
        iconSelected: registersIconSelected,
        permission: AlarmCentersPermissions,
      },
    ],
    permission: [],
  },
  {
    name: 'Configurações',
    link: 'settings',
    icon: SettingsIcon,
    iconSelected: SettingsIconSelected,
    iconOpen: IconOpen,
    iconOpenSelected: IconOpenSelected,
    submenu: [
      {
        name: 'Credenciais',
        link: 'settings/credentials',
        icon: credentialsIcon,
        iconSelected: credentialsIconSelected,
        permission: CredentialsPermissions,
      },
      {
        name: 'Dados da Empresa',
        link: 'settings/company-data',
        icon: dataCompanyIcon,
        iconSelected: dataCompanyIconSelected,
        permission: CompaniesPermissions,
      },
      {
        name: 'Integrações de Entrada',
        link: 'settings/inputs',
        icon: incomingServer,
        iconSelected: incomingServerSelected,
        permission: ServerEntradaPermissions,
      },
      {
        name: 'Integrações de Saída',
        link: 'settings/outputs',
        icon: outgoingServer,
        iconSelected: outgoingServerSelected,
        permission: ServerSaidaPermissions,
      },
    ],
    permission: [],
  },
  {
    name: 'Administrativo',
    link: 'administrative',
    icon: adminIcon,
    iconSelected: adminIconSelected,
    iconOpen: IconOpen,
    iconOpenSelected: IconOpenSelected,
    submenu: [
      {
        name: 'Cotas',
        link: 'administrative/quotas',
        icon: quotaIcon,
        iconSelected: quotaIconSelected,
        permission: QuotasPermissions,
      },
      {
        name: 'Empresas',
        link: 'administrative/companies',
        icon: companyIcon,
        iconSelected: companyIconSelected,
        permission: CompaniesPermissions,
      },
    ],
    permission: [],
  },
]

const RoutesPagesPathsEnum = [
  {path: '/tutorials/digifort', title: 'Tutoriais - Digifort'},
  {path: '/tutorials/dguard', title: 'Tutoriais - D-guard'},
  {path: '/tutorials/moni', title: 'Tutoriais - Moni'},
  {path: '/forbidden', title: 'Acesso Negado'},
  {path: '/dashboard', title: 'Dashboard'},
  {path: '/events', title: 'Eventos'},
  {path: '/license-plate', title: 'LPR'},
  {path: '/notifications', title: 'Notificações'},
  {path: '/facial-recognition', title: 'Reconhecimento Facial'},
  {path: '/camera-mosaic', title: 'Mosaico'},
  {path: '/upload-dataset', title: 'Upload de Dataset'},
  {path: '/registers/devices', title: 'Cadastros - Dispositivos'},
  {path: '/registers/analytic-cameras', title: 'Cadastros - Câmeras Analíticas'},
  {path: '/registers/brainbox', title: 'Cadastros - Brain Box'},
  {path: '/registers/clients', title: 'Cadastros - Clientes'},
  {path: '/registers/lists', title: 'Cadastros - Listas'},
  {path: '/registers/users', title: 'Cadastros - Usuários'},
  {path: '/registers/edge-servers', title: 'Cadastros - Servidores de Borda'},
  {path: '/registers/alarm-centers', title: 'Cadastros - Central de Alarme'},
  {path: '/settings/inputs', title: 'Configurações - Integrações de Entrada'},
  {path: '/settings/outputs', title: 'Configurações - Integrações de Saída'},
  {path: '/settings/credentials', title: 'Configurações - Credenciais'},
  {path: '/settings/company-data', title: 'Configurações - Dados da Empresa'},
  {path: '/administrative/quotas', title: 'Administrativo - Cotas'},
  {path: '/administrative/companies', title: 'Administrativo - Empresas'},
  {path: '/terms', title: 'Termos'},
]

export function resolveSidebarTitle(location: Location, user?: User | null) {
  const pathname = location.pathname
  const locationSelected = RoutesPagesPathsEnum.find((it) => pathname.includes(it.path))
  return {
    pageTitle: pathname === '/' ? InitialRoutesWithPermissions(user).name : locationSelected?.title,
    link: locationSelected?.path ?? '',
  }
}
